import actions from './actions'
import mutations from './mutations'

const sqlReports = {
    namespaced: true,
    state: {
        reports: [],
        reportsList: [],
        roleCategories: [],
        categoriesList: [],
        reportsListFilters: {
            fromDate: null,
            toDate: null,
            sqlQuery: null
        },
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        loading: false
    },
    mutations,
    actions
}

export default sqlReports
